export default __webpack_public_path__ + "static/media/ref-szpital-bielskobiala.84920fdf.pdf";